module.exports = __webpack_public_path__ + "img/operating_records_dish_tr.325d94ca.svg";